import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './oauth-callback.styles'
import Spinner from 'pobble-components/dist/spinner'

const OauthCallback = ({ classes, onMount }) => {
  useEffect(
    () => {
      onMount()
    },
    [onMount]
  )
  return (
    <div className={classes.container}>
      <Spinner />
    </div>
  )
}

export default injectSheet(styles)(OauthCallback)
